import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Panel } from '~/eds/src/components/Panel/Panel';
import { StatusMessage } from '~/eds/src/components/StatusMessage/StatusMessage';
import { slices } from '~/redux/slices';

import { mapAlgoStatusMessageProps } from './utils';

export const AlgoStatusPanel = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { activeFile } = useSelector(slices.upload.selectors.selectActiveFile);

  if (!activeFile) {
    return null;
  }

  return (
    <Panel
      hidden={{
        placement: 'left',
        onHide: () => {
          dispatch(slices.upload.actions.resetFileConfiguration());
        },
      }}
      position="right"
      title={intl.formatMessage({
        id: 'AlgoStatusPanel.title',
        defaultMessage: 'AlgoStatus',
        description: 'Panel title for algorithm status display',
      })}
    >
      <Layout direction="column" spacing={2}>
        {activeFile.algoStatuses.map((algoStatus) => (
          <StatusMessage
            key={algoStatus.status}
            {...mapAlgoStatusMessageProps(algoStatus, intl)}
          />
        ))}
      </Layout>
    </Panel>
  );
};
